import { Component, OnInit } from '@angular/core';
import {University} from '../model/university';
import {DataManagementService} from '../services/data-management.service';

@Component({
  selector: 'app-student-bidding',
  templateUrl: './student-bidding.component.html',
  styleUrls: ['./student-bidding.component.css']
})
export class StudentBiddingComponent implements OnInit {

  sourceUniversities: University[];

  targetUniversities: University[];

  constructor(private dmService: DataManagementService) {
  }

  getUniversities() {
    this.dmService.getUniversities().subscribe(universities => {
      if (!localStorage.hasOwnProperty('sourceUniversities')) {
        localStorage.setItem('sourceUniversities', JSON.stringify(universities.data));
        this.sourceUniversities = JSON.parse(localStorage.getItem('sourceUniversities'));
      } else if (localStorage.hasOwnProperty('sourceUniversities')) {
        localStorage.setItem('sourceUniversities', JSON.stringify(universities.data));
      }
    });
  }

  moveToTarget(e) {
    // console.log(e);
    localStorage.setItem('targetUniversities', JSON.stringify(this.targetUniversities));
    localStorage.setItem('sourceUniversities', JSON.stringify(this.sourceUniversities));
  }

  moveToSource(e) {
    // console.log(e);
    localStorage.setItem('targetUniversities', JSON.stringify(this.targetUniversities));
    localStorage.setItem('sourceUniversities', JSON.stringify(this.sourceUniversities));
  }

  sourceReorder(e) {
    // console.log(e);
    localStorage.setItem('sourceUniversities', JSON.stringify(this.sourceUniversities));
  }

  targetReorder(e) {
    // console.log(e);
    localStorage.setItem('targetUniversities', JSON.stringify(this.targetUniversities));
  }

  ngOnInit() {
    if (!localStorage.hasOwnProperty('sourceUniversities')) {
      this.getUniversities();
    }
    if (!localStorage.hasOwnProperty('targetUniversities')) {
      localStorage.setItem('targetUniversities', '[]');
    }
    if (localStorage.hasOwnProperty('sourceUniversities')) {
      this.sourceUniversities = JSON.parse(localStorage.getItem('sourceUniversities'));
    }
    if (localStorage.hasOwnProperty('targetUniversities')) {
      this.targetUniversities = JSON.parse(localStorage.getItem('targetUniversities'));
    }
  }
}
